<div class="paper cover-pages-list-wrapper">
  <div class="cover-pages-list-head">
    <span>Cover Page</span>
    <span>From Number</span>
    <span>Sent From</span>
    <span>Actions</span>
  </div>

  <ul class="cover-pages-list">
    <li *ngFor="let coverPage of coverPages" class="cover-pages-list__item">
      <span>{{ coverPage.title }}</span>
      <span>{{ coverPage.fromNumber }}</span>
      <span>{{ coverPage.sentFrom }}</span>

      <div class="cover-pages-list__actions">
        <button class="icon-btn icon-btn_md" (click)="editClick.emit(coverPage)">
          <img src="assets/img/icons/edit.webp" alt="Edit cover page" />
        </button>

        <button class="icon-btn icon-btn_md" (click)="deleteClick.emit(coverPage)">
          <img src="assets/img/icons/delete-orange.svg" alt="Delete cover page" />
        </button>
      </div>
    </li>
  </ul>

  <button class="btn_plain cover-pages-list__add-button" (click)="addClick.emit()">Add cover page</button>
</div>
